import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { HttpService } from '../shared/services/http.service';

import { MaintenancePeriod } from './models/maintenance-period';

@Injectable({ providedIn: 'root' })
export class MaintenancePeriodGateway {
    private readonly httpService = inject(HttpService);

    /** Resolves to null when no maintenance is scheduled (204). */
    getCurrent(): Promise<MaintenancePeriod | null> {
        return firstValueFrom<MaintenancePeriod | null>(this.httpService.get('/v1/maintenance-period/current'));
    }
}
